import { AccordionSection, FormatSectionTitleFn } from 'components/common-form/sidePanel/AccordionSection';
import { OpenInModalContent } from 'components/shared/OpenInModal/OpenInModalContent';
import { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import { useToggle } from 'usehooks-ts';

export type AccordionKey = 'prices' | 'greeks' | 'productGreeks' | 'historicalAverageCorrelations' | 'fees' | 'metrics';

type Props = {
  sectionName: string;
  noModal?: boolean;
  getTitle: FormatSectionTitleFn<string>;
};

export function NonUniqueSectionItem({ sectionName, getTitle, children, noModal }: PropsWithChildren<Props>) {
  const [isOpen, toggleOpen] = useToggle();
  const { formatMessage } = useIntl();
  const modalTitle = getTitle(sectionName, k => formatMessage({ id: k }));

  return (
    <AccordionSection
      section={sectionName}
      getTitle={getTitle}
      showSpinners={false}
      disabled={false}
      openModal={noModal ? undefined : toggleOpen}
      e2e={`toggle-${sectionName}`}
    >
      <div className="card-body" data-e2e={`panel-${sectionName}`}>
        <OpenInModalContent isModalOpen={isOpen} modalTitle={modalTitle} toggleModal={toggleOpen}>
          {children}
        </OpenInModalContent>
      </div>
    </AccordionSection>
  );
}
